// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6723) return "static/chunks/worker-chunks-dd510486138de22e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "a345344caf39165e" + ".js";
};